import React from "react"
import propTypes from "prop-types"
import { Link } from "react-router-dom"
import { Button } from "reactstrap"
import "assets/scss/custom/components/table-interactive.scss"

const ProvidersItemList = ({ item, canDelete, canEdit, openEditModal, openDeleteModal }) => {
  const styleCenterTable = { textAlign: "center", verticalAlign: "middle" }
  const { id, name, email, phone, rfc, observations } = item
  // refactor candidate
  const renderEditButton = () => {
    if (!canEdit) {
      return null
    }

    return (
      <Button color="primary" className="m-1" onClick={() => openEditModal(id)}>
        <i className="fa fa-edit" />
      </Button>
    )
  }

  const renderDeleteButton = () => {
    if (!canDelete) {
      return null
    }

    return (
      <Button color="danger" onClick={() => openDeleteModal(item)}>
        <i className="fa fa-trash" />
      </Button>
    )
  }

  return (
    <tr key={id}>
      <td style={styleCenterTable} className="text-cell">
        <Link to={{ pathname: `/providers/${item.id}` }}>{name}</Link>
      </td>
      <td style={styleCenterTable} className="text-cell">{email}</td>
      <td style={styleCenterTable} className="text-cell">{phone}</td>
      <td style={styleCenterTable} className="text-cell">{rfc || "--"}</td>
      <td style={styleCenterTable} className="text-cell">{observations || "--"}</td>
      <td style={styleCenterTable}>
        {renderEditButton()}
        {renderDeleteButton()}
      </td>
    </tr>
  )
}

ProvidersItemList.propTypes = {
  item: propTypes.object,
  canDelete: propTypes.bool,
  canEdit: propTypes.bool,
  openEditModal: propTypes.func,
  openDeleteModal: propTypes.func,
}

export default ProvidersItemList
